export default {
  header: 'Podsumowanie zamówienia',
  buttons: {
    checkout: 'Bezpieczna płatność',
    continue: 'Kontynuuj',
    add_products: '+ Dodaj produkty',
    add_items: '+ Dodaj więcej pozycji',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Twój koszyk jest pusty <br/> Dodaj produkty, aby zacząć',
  },
  promo_code_banner: {
    single_use: 'Rabat {{discount}} - {{code}}',
    multi_use: 'Rabat {{discount}} na {{count}} zamówieniach - {{code}}',
    redeem: 'WYKORZYSTAJ',
    redeemed: 'WYKORZYSTANO',
  },
  upsell: {
    title: 'Inni zamawiają też',
  },
  rewards: {
    title: 'Zapłać punktami',
    description: '<highlight>Zaloguj się</highlight>, aby zapłacić punktami',
  },
  already_member: 'Masz już konto?',
  sign_in: 'Zaloguj się',
  summary: {
    subtotal: 'Suma częściowa',
    delivery: 'Dostawa',
    pickup: 'Odbiór',
    total: 'Łącznie',
    free: 'Bezpłatnie',
  },
  footer: {
    member_earning: '+{{points}} pkt po zamówieniu · saldo {{balance}} pkt',
    guest_earning: 'Zarejestruj się, aby zbierać punkty za to zamówienie',
  },
};
